import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Decimal from './Decimal';

const getPlaceholderByDecimals = (decimals, fallbackDecimals) => {
    const parsedDecimals = Number.parseInt(decimals, 10);
    const hasValidDecimals = Number.isInteger(parsedDecimals) && parsedDecimals >= 0;
    const finalDecimals = hasValidDecimals ? parsedDecimals : fallbackDecimals;

    if (finalDecimals <= 0) return '0';
    return `0.${'0'.repeat(finalDecimals)}`;
};

const propTypes = {
    label: PropTypes.any,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    error: PropTypes.any,
    mandatory: PropTypes.bool,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    description: PropTypes.string,
    labelMode: PropTypes.string,
    currencySymbol: PropTypes.string,
    hint: PropTypes.string,
    limitDecimals: PropTypes.number,
};

const Currency = ({ className, currencySymbol = '', hint, limitDecimals, ...props }) => {
    const placeholderHint = hint || getPlaceholderByDecimals(limitDecimals, 2);

    return (
        <Decimal
            {...props}
            className={className || 'fm-field-currency'}
            hint={placeholderHint}
            limitDecimals={limitDecimals}
            postComponent={currencySymbol ? <span>{currencySymbol}</span> : null}
        />
    );
};

Currency.displayName = 'Currency';
Currency.propTypes = propTypes;

export default memo(Currency);
